export const getPromotionsApiUrl = (domain = '') => {
  return domain
    .trim()
    .replace(/\/$/, '')
    .replace(/^(https?:\/\/)admin\./i, '$1bonus.');
};

export const getPromotionsApiKey = (domain = '') => {
  const hostname = domain
    .trim()
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    .split(':')[0]
    .toLowerCase();

  let keysByDomain = {};

  try {
    keysByDomain = JSON.parse(process.env.VUE_APP_BONUS_KEYS || '{}');
  } catch (error) {
    console.error('VUE_APP_BONUS_KEYS no contiene un JSON válido.', error);
  }

  const matchedDomain = Object.keys(keysByDomain).find(configuredDomain => {
    const normalizedDomain = configuredDomain.trim().replace(/^\./, '').toLowerCase();
    return hostname === normalizedDomain || hostname.endsWith(`.${normalizedDomain}`);
  });

  return matchedDomain ? keysByDomain[matchedDomain] : (process.env.VUE_APP_BONUS || '');
};
